'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _draftJs = require('draft-js');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var getRelativeParent = function getRelativeParent(element) {
  if (!element) {
    return null;
  }

  var position = window.getComputedStyle(element).getPropertyValue('position');

  if (position !== 'static') {
    return element;
  }

  return getRelativeParent(element.parentElement);
};

var AddPlaceholderButton = function (_React$Component) {
  _inherits(AddPlaceholderButton, _React$Component);

  function AddPlaceholderButton(props) {
    _classCallCheck(this, AddPlaceholderButton);

    var _this = _possibleConstructorReturn(this, (AddPlaceholderButton.__proto__ || Object.getPrototypeOf(AddPlaceholderButton)).call(this, props));

    _this.calculatePosition = function () {
      if (_this.toolbar) {
        var relativeParent = getRelativeParent(_this.toolbar.parentElement);
        var relativeRect = relativeParent ? relativeParent.getBoundingClientRect() : window.document.body.getBoundingClientRect();
        var selectionRect = (0, _draftJs.getVisibleSelectionRect)(window);

        if (selectionRect) {
          var style = {
            top: selectionRect.top - relativeRect.top - 35,
            left: selectionRect.left - relativeRect.left + selectionRect.width / 2,
            transform: 'translate(-50%) scale(1)'
          };

          if (JSON.stringify(style) !== JSON.stringify(_this.state.style)) {
            _this.setNewPosition(style);
          }
        }
      }
    };

    _this.toggleExpansion = function (e) {
      e.preventDefault();

      _this.setState({
        expanded: !_this.state.expanded
      });
    };

    _this.handleInsertPlaceholder = function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.toggleExpansion(e);

      _this.props.insertPlaceholder(_this.props.blankText);
    };

    _this.state = {
      style: {},
      expanded: false
    };
    return _this;
  }

  _createClass(AddPlaceholderButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.calculatePosition();
      }, 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!newProps.editorEnabled) {
        return;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this3 = this;

      setTimeout(function () {
        return _this3.calculatePosition();
      }, 0);
    }
  }, {
    key: 'setNewPosition',
    value: function setNewPosition() {
      var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.setState({
        style: style
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var editorState = this.props.editorState;
      var expanded = this.state.expanded; // Don't show add blank button if user selected a range

      if (!editorState.getSelection().isCollapsed()) return null;
      return _react2.default.createElement('div', {
        className: 'md-editor-toolbar md-editor-toolbar--isopen md-editor-toolbar-add-blank',
        style: this.state.style,
        ref: function ref(node) {
          _this4.toolbar = node;
        }
      }, _react2.default.createElement('div', {
        className: 'md-RichEditor-controls'
      }, _react2.default.createElement('span', {
        className: 'md-RichEditor-styleButton md-RichEditor-linkButton hint--top',
        onMouseDown: function onMouseDown(e) {
          return _this4.toggleExpansion(e);
        },
        'aria-label': 'Add a bracket'
      }, '+'), expanded && _react2.default.createElement(_CSSTransitionGroup2.default, {
        transitionName: 'md-example',
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 100,
        transitionAppearTimeout: 100,
        transitionAppear: true
      }, _react2.default.createElement('span', {
        className: 'md-RichEditor-styleButton md-RichEditor-linkButton hint--top',
        onMouseDown: function onMouseDown(e) {
          return _this4.handleInsertPlaceholder(e);
        }
      }, 'Add a bracket'))));
    }
  }]);

  return AddPlaceholderButton;
}(_react2.default.Component);

AddPlaceholderButton.propTypes = {
  editorEnabled: _propTypes2.default.bool,
  editorState: _propTypes2.default.object,
  blankText: _propTypes2.default.string,
  insertPlaceholder: _propTypes2.default.func.isRequired,
  focus: _propTypes2.default.func
};
exports.default = AddPlaceholderButton;